module.exports = __webpack_public_path__ + "img/Stopsign.6c09af27.png";